<!-- @ts-nocheck -->
<template>
  <div class="infocenter" ref="infocenter">
    <div class="header" :class="{ stickyheader: scrollposition > 0 }">
      <h4 style="float: left">{{ $t("infocenter.infocenter") }}</h4>
      <q-btn flat round dense icon="close" style="float: right" @click="closeOnClick" />
      <!--<q-btn flat round dense icon="more_vert" style="float: right" />
      <q-btn flat round dense icon="search" style="float: right" />-->
      <div class="search">
        <q-btn
          :icon="item.categoryIcon"
          v-for="(item, index) in getCategoryButtons()"
          v-bind:key="'button' + index"
          @click="toggleCategory(item.category)"
          style="border: 1px solid #000"
          :class="{ buttonSelected: selectedCategories.includes(item.category) }"
        >
          <q-badge color="red" floating v-if="uniqsCategory[item.category]">{{
            uniqsCategory[item.category]
          }}</q-badge>
          <q-tooltip anchor="bottom middle" self="bottom middle">
            {{ item.category }}
          </q-tooltip>
        </q-btn>
      </div>
    </div>
    <slot></slot>
    <div class="main">
      <div class="section" v-if="getUnread().length > 0">{{ $t("infocenter.unread") }}</div>
      <div
        v-for="(item, index) in getUnread()"
        v-bind:key="'unread' + index"
        class="componentWapper"
      >
        <component v-bind:is="item.component" v-model="item.payload" @closeOnClick="closeOnClick" />
      </div>
      <div class="section" v-if="getRead().length > 0">{{ $t("infocenter.read") }}</div>
      <div v-for="(item, index) in getRead()" v-bind:key="'read' + index" class="componentWapper">
        <component v-bind:is="item.component" v-model="item.payload" @closeOnClick="closeOnClick" />
      </div>
    </div>
    <q-scroll-observer debounce="200" :scroll-target="scrollTarget()" @scroll="scrollHandler" />
  </div>
</template>

<script lang="ts">
import { Prop, Watch, Vue } from "vue-property-decorator";
import { INewstype } from "./IstInfoCenter";

//Vue.use(VueHotkey);

export default class App extends Vue {
  pNewstype: INewstype[] = [];
  scrollposition = 0;
  uniqsCategory: any;
  selectedCategories: string[] = [];

  @Prop({ default: null, type: [Array] })
  newsItems!: INewstype[];

  escapePressed() {
    this.$emit("escapePressed");
  }

  scrollTarget(): Element {
    return this.$refs.infocenter as Element;
  }

  scrollHandler(event) {
    this.scrollposition = event.position;
  }

  mounted() {
    this.pNewstype.length = 0;
    if (this.newsItems) {
      this.pNewstype = this.newsItems;
    }

    this.uniqsCategory = this.pNewstype.reduce((acc, val) => {
      if (val.unread == true) {
        acc[val.category] =
          acc[val.category] === undefined && val.unread ? 1 : (acc[val.category] += 1);
      }
      return acc;
    }, {});
  }

  closeOnClick() {
    this.$emit("close");
  }

  @Watch("newsItems", {})
  onChangeNewsItems(newtags: INewstype[]) {
    this.pNewstype = [];
    if (newtags) {
      this.pNewstype = newtags;
    }
    this.uniqsCategory = this.pNewstype.reduce((acc, val) => {
      if (val.unread == true) {
        acc[val.category] = acc[val.category] === undefined ? 1 : (acc[val.category] += 1);
      }
      return acc;
    }, {});
  }

  getCategoryButtons() {
    const result = [...new Map(this.pNewstype.map((item) => [item["category"], item])).values()];
    return result;
  }

  getUnread() {
    return this.pNewstype.filter(
      (a) =>
        a.unread &&
        (this.selectedCategories.includes(a.category) || this.selectedCategories.length === 0)
    );
  }

  getRead() {
    return this.pNewstype.filter(
      (a) =>
        !a.unread &&
        (this.selectedCategories.includes(a.category) || this.selectedCategories.length === 0)
    );
  }

  toggleCategory(categori: string) {
    const indexCat = this.selectedCategories.indexOf(categori);
    if (indexCat > -1) {
      this.selectedCategories.splice(indexCat, 1);
    } else {
      this.selectedCategories.push(categori);
    }
  }

  isSelectedCategory(categori: string) {
    return this.selectedCategories.includes(categori);
  }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";

.infocenter {
  background-attachment: scroll;
  background-clip: border-box;
  background-color: rgb(255, 255, 255);
  background-image: none;
  background-origin: padding-box;
  background-size: auto;
  bottom: 0px;
  box-sizing: border-box;
  color: rgb(0, 88, 108);
  direction: ltr;
  display: block;
  height: 100vh;
  right: 0px;
  overflow: auto;
  top: 0px;
  transform: matrix(1, 0, 0, 1, 0, 0);
  width: 300px;
  z-index: 6000;
  position: fixed;
  -webkit-font-smoothing: antialiased;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-box-shadow: -4px 0px 10px 0px rgba(0, 0, 0, 0.42);
  box-shadow: -4px 0px 10px 0px rgba(0, 0, 0, 0.42);

  & .q-drawer__content {
    padding-top: 65px;
  }

  & .header {
    width: 100%;
    min-height: 64px;
    border-bottom: 1px solid #0002;
    padding: 8px;
  }

  & .stickyheader {
    position: sticky;
    top: 0;
    background-color: #fff;
    box-shadow: 0 0 0.5em rgba(0, 0, 0, 0.5);
    z-index: 1;
    border-radius: 0px 0px 10px 10px;
  }

  & .buttonSelected {
    background-color: $ist-grey-light;
  }

  .section {
    padding: 20px;
    border-bottom: 1px solid #0009;
  }

  .search {
    width: 100%;
    padding: 8px;
    clear: both;

    & > * {
      margin: 4px;
      width: 40px;
      height: 40px;
    }
    & > * > .q-btn__content {
      color: #fff;
    }
  }
  .componentWapper {
    border-bottom: 1px solid #0002;
    position: relative;
  }
}
</style>
